/**
 * Stores networked avatar state.
 * @namespace avatar
 * @component networked-avatar
 */
AFRAME.registerComponent("networked-avatar", {
  schema: {
    left_hand_pose: { default: 0 },
    right_hand_pose: { default: 0 },
    front: { default: 0},
    right: {default: 0},
    sitAnimation: { default: ""},
    lockCamera: { default: false},
    lockedRotMatrix: {}
  },
  tick() {
    const avatarAnim = this.el.querySelector('[avatar-animation]');
    if(!avatarAnim || !avatarAnim.components || !avatarAnim.components['avatar-animation']) return;
    const {front, right, sitAnimation, lockCamera, lockedRotMatrix} = this.data
    if(avatarAnim.components['avatar-animation'].data.front !== front || 
    avatarAnim.components['avatar-animation'].data.right !== right) {
      avatarAnim.setAttribute('avatar-animation',{front, right});
    }

    if(avatarAnim.components['avatar-animation'].data.sitAnimation !== sitAnimation) {
      avatarAnim.setAttribute('avatar-animation',{sitAnimation});
    }

    if(avatarAnim.components['avatar-animation'].data.lockCamera !== lockCamera) {
      avatarAnim.setAttribute('avatar-animation',{lockCamera});
    }

    if(avatarAnim.components['avatar-animation'].data.lockedRotMatrix !== lockedRotMatrix) {
      avatarAnim.setAttribute('avatar-animation',{lockedRotMatrix});
    }
  }
});
